import React from 'react'
import { QRCode, Typography } from 'antd'
import styled from 'styled-components'

import { FlexColumn, FlexRow } from '../../../FlexboxReusables/FlexItems'
import { SuccessfulPaymentResponse } from '../../types'
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import { domain } from '../../../../globals'

type SummaryStepProps = {
  successfulPaymentResponse?: SuccessfulPaymentResponse
}

export enum LinkType {
  PARTICIPANTS = 'participants',
  STATISTICS = 'statistics'
}

export const SummaryStep: React.FC<SummaryStepProps> = ({ successfulPaymentResponse }) => {
  if (!successfulPaymentResponse) {
    return null
  }
  const { linkForParticipants, linkForStatistics, paidParticipantsCount } = successfulPaymentResponse

  const buildUrl = (link: string, type: LinkType) => {
    switch (type) {
      case LinkType.PARTICIPANTS:
        return (
          <Link to={`/exams/${link}`} target="_blank">
            {`${window.location.origin}/exams/${link}`}
          </Link>
        )
  
      case LinkType.STATISTICS:
        return (
          <Link to={`/statistics/${link}`} target="_blank">
            {`${window.location.origin}/statistics/${link}`}
          </Link>
        )
    }
  }

  return (
    <>
      <FlexRow margin='2em 0'>
        <FlexColumn>
          <Typography.Title level={4}>
            <FormattedMessage id='buyCourseAccess.summary.thankYou' />
          </Typography.Title>
          <Typography.Title level={5}>
            <FormattedMessage id='buyCourseAccess.summary.youWillReceiveAnEmail' />
          </Typography.Title>
          <Typography.Text>
            <FormattedMessage id='buyCourseAccess.summary.yourOrderNumberIs' /> {" "}
            {`ON-${successfulPaymentResponse.currentInvoiceNumber}`}
          </Typography.Text>
        </FlexColumn>
      </FlexRow>

      <InfoRow>
        <InfoColumn>
          <Typography.Title level={5}>
            <FormattedMessage id='buyCourseAccess.summary.linkForParticipants' />
          </Typography.Title>
          <Typography.Text>
            {buildUrl(linkForParticipants, LinkType.PARTICIPANTS)}
          </Typography.Text>
          <InfoText>
            <FormattedMessage id='buyCourseAccess.summary.infoText1' />
            <br />
            <FormattedMessage id='buyCourseAccess.summary.infoText2' />
            <br />
            <FormattedMessage
              id='buyCourseAccess.summary.infoText3'
              values={{ count: paidParticipantsCount }}
            />
          </InfoText>
        </InfoColumn>
        <QRCode value={`${domain}/exams/${linkForParticipants}`} size={140}/>
      </InfoRow>

      {/* CURRENTLY NOT IN USE, COMMENT IN AS SOON AS STATISTICS ARE LIVE */}

      {/* <InfoRow>
        <InfoColumn>
          <Typography.Title level={5}>
            <FormattedMessage id='buyCourseAccess.summary.linkToStatistics' />
          </Typography.Title>
          <Typography.Text>
            {buildUrl(linkForStatistics, LinkType.STATISTICS)}
          </Typography.Text>
          <WarningText>
            <FormattedMessage id='buyCourseAccess.summary.warningText' />
          </WarningText>
        </InfoColumn>
      </InfoRow> */}
    </>
  )
}

export default SummaryStep

const InfoRow = styled(FlexRow)`
  margin: 1em auto;
  width: 70%;
  justify-content: flex-start;
`
const InfoColumn = styled(FlexColumn)`
  margin: 1em auto;
  align-items: flex-start;
`

const InfoText = styled(Typography.Text)`
  margin: 0.5em 0;
  color: 'grey';
  font-style: italic;
`
